























import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop({ default: "" })
  public value!: string;

  @Emit("change")
  private changed(evt: Event) {
    if (evt.target) {
      return (evt.target as HTMLTextAreaElement).value;
    }
    return this.value;
  }
}
